import React from "react";

export default function ContactDetailsLiquid() {
  return (
    <section
      className="section-liquid contact-details-section"
      style={{ paddingTop: "0" }}
    >
      <div className="container-liquid">
        <div
          className="contact-details-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "30px",
          }}
        >
          <div
            className="glass-secondary liquid-float"
            style={{
              padding: "40px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                marginBottom: "20px",
              }}
            >
              📍
            </div>
            <h3
              className="heading-liquid"
              style={{
                fontSize: "1.5rem",
                marginBottom: "16px",
              }}
            >
              Mumbai Office
            </h3>
            <div
              className="text-liquid"
              style={{
                lineHeight: "1.6",
              }}
            >
              <div style={{ marginBottom: "8px" }}>D-2, Bhadran Nagar,</div>
              <div style={{ marginBottom: "16px" }}>
                Malad West, Mumbai 400064
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  marginTop: "20px",
                }}
              >
                <a
                  href="tel:9867779087"
                  className="glass-button"
                  style={{
                    padding: "12px 20px",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                  }}
                >
                  📞 +91 (986) 777-9087
                </a>
                <button
                  className="glass-button glass-button-primary"
                  onClick={() =>
                    window.open("https://wa.me/9867779087", "_blank")
                  }
                  style={{
                    padding: "12px 16px",
                  }}
                >
                  💬
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
